import advancedSearchTrackingService from "../../../../../../sub-modules/advanced-search/services/tracking/advancedSearchTrackingService";
import type { SaveSearchTriggerModalProps } from "../../components/SaveSearchTriggerModal/SaveSearchTriggerModal";
import SaveSearchTriggerModal from "../../components/SaveSearchTriggerModal/SaveSearchTriggerModal";

const SaveSearchTriggerModalTracked = (props: SaveSearchTriggerModalProps) => {
    const handleTrackedConfirm = () => {
        advancedSearchTrackingService.saveSearch.trackConfirmTriggerSaveAction("onExport");
        props.onConfirm();
    };

    const handleTrackedCancel = () => {
        advancedSearchTrackingService.saveSearch.trackCancelTriggerSaveAction("onExport");
        props.onCancel();
    };

    return (
        <SaveSearchTriggerModal
            {...props}
            onConfirm={handleTrackedConfirm}
            onCancel={handleTrackedCancel}
        />
    );
};

export default SaveSearchTriggerModalTracked;
